// extracted by mini-css-extract-plugin
export var avatarContainer = "_92-0";
export var avatarTypingWave = "_92-i";
export var gray = "_92-f";
export var green = "_92-c";
export var icon = "_92-9";
export var image = "_92-1";
export var lg = "_92-6";
export var md = "_92-5";
export var presenceDot = "_92-b";
export var red = "_92-d";
export var sm = "_92-4";
export var status = "_92-a";
export var typingDot = "_92-h";
export var typingPill = "_92-g";
export var xl = "_92-7";
export var xs = "_92-3";
export var xxl = "_92-8";
export var xxs = "_92-2";
export var yellow = "_92-e";